import React, { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { Modal, Container, Row, Col, Table, Button } from "react-bootstrap";
import { store } from "../../App";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import {
  exportToExcel,
  datetime,
  formatNumberIndianWithDecimal,
  generatePdf,
  commonSelectProps,
} from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import { Field, FormikProvider, Form, useFormik } from "formik";
import MasterService from "../../Services/MasterService";
import { IoIosReturnLeft } from "react-icons/io";
import Select from "react-select";
export default function KPIsvaluereport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [currentdate, setcurrentdate] = useState("");
  const [currenttime, setcurrenttime] = useState("");
  const [data, setData] = useState([]);
  const [subTableData, setSubTableData] = useState([]);
  const [Deptlist, setDeptlist] = useState([]);
  const [distlist, setDistrictList] = useState();
  const [searchText, setSearch] = useState("");
  const [SubTableEnb, setSubTableEnb] = useState(false);
  const [SubDistTableEnb, setSubDistTableEnb] = useState(false);
  const [subDistTableData, setsubDistTableData] = useState([]);
  const [maintablenb, setmaintablenb] = useState(true);
  const [searchdistSub, setSearchdistsub] = useState("");
  const [selecteddist, setselecteddist] = useState("");
  const [selectedmandal, setselectedmandal] = useState("");

  const [searchSub, setSearchsub] = useState("");
  const [yearList, setYearList] = useState([]);
  const [monthList, setMonthList] = useState([]);

  const [DrillType, setDrillType] = useState();
  const [Entry, setEntry] = useState();
  const [Head_id, setHead] = useState();

  const [TargetCountEnb, setTargetCountEnb] = useState(false);
  const [PendingAchEnb, setPendingAchEnb] = useState(false);
  const [TargetMandalEnb, setTargetMandalEnb] = useState(false);
  const [AchMandalEnb, setAchMandalEnb] = useState(false);

  const [mandaltargetenb, setmandaltargetenb] = useState(false);
  const [AchievementNamesEnb, setAchievementNamesEnb] = useState(false);
  const [AchievementNamesdata, setAchievementNamesdata] = useState(false);

  const [TargetsData, setTargetsData] = useState([]);
  const [TargetsmandalData, setTargetsmandalData] = useState([]);
  const [AchmandalData, setAchmandalData] = useState([]);

  const [TargetNames, setTargetNames] = useState([]);
  const [PendingAChievementData, setPendingAChievementData] = useState([]);
  const [PendingmandalData, setPendingmandalData] = useState([]);
  const [Pendingmandalenb, setPendingmandalenb] = useState(false);
  const [selectedpendingDistrictName, setSelectedpendingDistrictName] =
    useState("");

  const [searchTargetsText, setsearchTargetsText] = useState("");
  const [searchmandalTargetsText, setsearchmandalTargetsText] = useState("");
  const [searchmandalAchText, setsearchmandalAchText] = useState("");

  const [searchPendingAchText, setsearchPendingAchText] = useState("");
  const [searchTargetNamesText, setsearchTargetNamesText] = useState("");
  const [searchAchNamesText, setsearchAchNamesText] = useState("");
  const [EnteredAchEnb, setEnteredAchEnb] = useState(false);

  const [monthPeriod, setMonthPeriod] = useState();

  let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");
  let username = localStorage.getItem("username");
  let deptId = localStorage.getItem("deptid");
  let district = localStorage.getItem("districtid");
  let roleid = localStorage.getItem("catid");
  let mandalid = localStorage.getItem(
    ulbdeptlist.includes(deptId) ? "ulbid" : "mandalid",
  );
  const formik = useFormik({
    initialValues: {
      department_id: "",
      district_id: "",
      year: "",
      month: "",
      entry_level: "",
      tr_entry_level: "",
    },
  });
  const [selecteddept, setselecteddept] = useState();
  const currentMonth = new Date().getMonth() + 1;

  const entryLevelOptions = [
    { value: "0", label: "All" },

    ...(["115", "116"].includes(roleid)
      ? [{ value: "secretariatLevel", label: "Secretariat Level" }]
      : []),

    ...(["115", "116", "114"].includes(roleid)
      ? [{ value: "hodLevel", label: "HOD Level" }]
      : []),

    ...(["115", "116", "114", "119", "113"].includes(roleid)
      ? [{ value: "districtLevel", label: "District Level" }]
      : []),

    ...(["115", "116", "114", "119", "113", "117", "111"].includes(roleid)
      ? [{ value: "mandalLevel", label: "Mandal Level" }]
      : []),
  ];

  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
    let params = { userId: username };

    MasterService.getAllDepts(params).then((res) => {
      if (res.data) {
        let options = res.data?.SDESC.map((item, i) => {
          return (
            <option key={i} value={item.dept_id}>
              {" "}
              {item.dept_name}{" "}
            </option>
          );
        });
        setDeptlist([
          { dept_id: "0", dept_name: "All" },
          ...(res.data?.SDESC ?? []),
        ]);
      }
    });
    MasterService.getfinyears().then((achievvalueres) => {
      if (achievvalueres.data) {
        let options = achievvalueres.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {" "}
              {item.value}{" "}
            </option>
          );
        });
        setYearList(achievvalueres.data);
      }
    });
    MasterService.getDistricts().then((res17) => {
      if (res17.data) {
        let options = res17.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {" "}
              {item.value}{" "}
            </option>
          );
        });
        setDistrictList(res17.data);
      }
    });

    if (["113", "119", "117", "111"].includes(roleid)) {
      setselecteddist(localStorage.getItem("districtname"));
    }
    if (["117", "111"].includes(roleid)) {
      setselectedmandal(
        localStorage.getItem(
          ulbdeptlist.includes(deptId) ? "ulbname" : "mandalname",
        ),
      );
    }

    if (["113", "114", "111", "115"].includes(roleid)) {
      formik.setFieldValue("department_id", deptId);
      formik.setFieldValue("district_id", district);
    }
    if (["119", "117"].includes(roleid)) {
      formik.setFieldValue("district_id", district);
    }
  }, []);

  useEffect(() => {
    getMonthList();
  }, []);

  const getMonthList = (e) => {
    let params = { userId: username };
    MasterService.getkpiMonths(params).then((finachievres) => {
      if (finachievres.data) {
        setMonthList(finachievres.data.SDESC);
      }
    });
  };

  const getData = (year, month) => {
    const deptId = formik.values.department_id;

    if (!deptId || !/^\d{1,5}$/.test(deptId)) {
      showAlertMessage("Department name should not be empty", "warning");
      return;
    }
    let params = {
      buttonType: "main",
      userId: username,
      deptId: formik.values.department_id,
      year: year,
      districtId: formik.values.district_id,
      monthOrder: month,
    };

    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.kpiValueReport(params)
      .then((res) => {
        setSubTableEnb(false);
        setSubDistTableEnb(false);
        setmaintablenb(true);
        if (res.data && res.data.SCODE == "01") {
          const currentData = res.data.SDESC[0].current_year_data_main || [];
          const previousData = res.data.SDESC[0].previous_year_data_main || [];

          // Convert previous data into map for quick lookup
          const prevMap = new Map(
            previousData.map((item) => [item.indicator_id, item]),
          );

          // Merge data
          const mergedData = currentData.map((item) => {
            const prev = prevMap.get(item.indicator_id);

            return {
              ...item,
              indicator_value_2024_25: prev?.indicator_value_2024_25 || 0,
            };
          });

          setData(mergedData);
        } else {
          showAlertMessage(res.data.SDESC, "warning");
          setData([]);
        }
      })
      .catch(() => {
        showAlertMessage("Failed to fetch data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const mandalWiseData = (dept_id) => {
    setselecteddept(dept_id);
    let params = {
      buttonType: "sub",
      userId: username,
      deptId: formik.values.department_id,
      year: formik.values.year,
      districtId: formik.values.district_id,
      monthOrder: formik.values.month,
    };

    store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.kpiValueReport(params)

      .then((res) => {
        setmaintablenb(false);
        setSubTableEnb(true);

        if (res.data && res.data.SCODE === "01") {
          const response = res.data.SDESC[0];

          const current = response.current_year_data || [];
          const previous = response.previous_year_data || [];
          const uptoMonth = response.upto_month_data || [];

          const mergedData = current.map((currItem) => {
            const prevItem = previous.find(
              (p) =>
                p.mandal_code === currItem.mandal_code &&
                p.indicator_id === currItem.indicator_id,
            );

            const uptoItem = uptoMonth.find(
              (u) =>
                u.mandal_code === currItem.mandal_code &&
                u.indicator_id === currItem.indicator_id,
            );

            return {
              ...currItem,

              indicator_value_2024_25:
                prevItem?.indicator_value_2024_25 ??
                currItem?.indicator_value_2024_25 ??
                0,

              upto_previous_month_sum: uptoItem?.upto_month_cumulative || 0,
            };
          });

          setSubTableData(mergedData);
        } else {
          showAlertMessage(res.data.SDESC, "warning");
          setSubTableData([]);
        }
      })
      .catch(() => {
        showAlertMessage("Failed to fetch data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const visibleIndicators = [
    ...new Map(
      (subTableData || []).map((item) => [
        item.indicator_id,
        {
          indicator_id: item.indicator_id,
          indicator_name: item.indicator_name,
          unit_name: item.unit_name,
          display_order: item.display_order,
        },
      ]),
    ).values(),
  ].sort((a, b) => a.display_order - b.display_order);
  console.log("subTableData:", subTableData);
  console.log("visibleIndicators:", visibleIndicators);
  const filteredData =
    searchText.length > 0 && data?.length
      ? data.filter((item) => {
          return (
            item &&
            Object.keys(item).some((key) => {
              const value = item[key];
              return (
                value !== null &&
                value
                  .toString()
                  .toLowerCase()
                  .includes(searchText.toLowerCase())
              );
            })
          );
        })
      : data;

  const filteredDataSub =
    searchSub.length > 0 && subTableData?.length
      ? subTableData.filter((item) => {
          return (
            item &&
            Object.keys(item).some((key) => {
              const value = item[key];
              return (
                value !== null &&
                value.toString().toLowerCase().includes(searchSub.toLowerCase())
              );
            })
          );
        })
      : subTableData;

  const searchValue = searchSub?.toLowerCase() || "";

  // Unique Indicators
  const allIndicators = [
    ...new Map(subTableData?.map((item) => [item.indicator_id, item])).values(),
  ].sort((a, b) => a.display_order - b.display_order);

  const indicatorSearch = allIndicators?.filter((ind) =>
    ind.indicator_name?.toLowerCase().includes(searchValue),
  );

  const groupedByMandal = subTableData?.reduce((acc, item) => {
    const key = item.mandal_code;

    if (!acc[key]) acc[key] = [];
    acc[key].push(item);

    return acc;
  }, {});

  // Mandal filtering
  const mandalRowsFiltered = Object.values(groupedByMandal).filter((rows) => {
    if (!searchValue) return true;

    const mandalName = rows[0]?.mandal_name?.toLowerCase() || "";

    // if indicator search, keep all mandals
    if (indicatorSearch.length > 0) return true;

    return mandalName?.includes(searchValue);
  });

  const hodenb = (id) => {
    formik.setFieldValue("year", "");
    formik.setFieldValue("entry_level", "");
    setData([]);
  };

  const headerStyle = {
    backgroundColor: "#4e835c",
    color: "white",
    padding: "5px",
    border: "1px solid white",
    wordBreak: "break-word",
  };

  const emptyData = () => {
    setData([]);
    setSubTableData([]);
    setSubDistTableEnb(false);
    setSubTableEnb(false);
  };

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "96%" }}>
        {" "}
        <div className="sa-title">
          {" "}
          <h2>
            Department - Indicator Wise{" "}
            <span> Monthly Cummulative Report </span>{" "}
          </h2>{" "}
        </div>{" "}
      </Container>
      <Container
        fluid
        style={{ width: "96%" }}
        className="outer-page-content-container"
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="py-2 px-4 mb-3">
              <Row>
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  <label htmlFor="department_id" className="mb-1 fw-bold">
                    {" "}
                    HOD Name{" "}
                  </label>
                  <Select
                    {...commonSelectProps({
                      name: "department_id",
                      options: Deptlist,
                      value: formik.values.department_id,
                      optionValueKey: "dept_id",
                      optionLabelKey: "dept_name",
                      formik,
                      isDisabled: ["113", "114", "111", "115"].includes(roleid),
                      extraOnChange: (option) => {
                        hodenb(option ? option.dept_id : "");
                        emptyData();
                      },
                    })}
                  />
                </Col>
                {["113", "119", "117", "111"].includes(roleid) && (
                  <Col
                    xs={12}
                    sm={12}
                    lg={3}
                    md={3}
                    xl={3}
                    xxl={3}
                    className="district-select"
                  >
                    {" "}
                    <label className="mb-1 fw-bold">District</label>
                    <Select
                      {...commonSelectProps({
                        name: "district_id",
                        options: distlist,
                        value: formik.values.district_id,
                        optionValueKey: "id",
                        optionLabelKey: "value",
                        formik,
                        isDisabled: true,

                        extraOnChange: (option) => {},
                      })}
                    />
                  </Col>
                )}

                {["117", "111"].includes(roleid) && (
                  <Col
                    xs={12}
                    sm={12}
                    lg={3}
                    md={3}
                    xl={3}
                    xxl={3}
                    className="district-select"
                  >
                    <label className="mb-1 fw-bold">
                      {ulbdeptlist.includes(
                        roleid === "111" ? deptId : formik.values.department_id,
                      )
                        ? "ULB"
                        : "Mandal"}
                    </label>
                    <Field
                      className="mb-3 form-control"
                      name="mandal_id"
                      type="text"
                      value={selectedmandal}
                      controlId="formBasicEmail"
                      disabled={true}
                      style={{ fontWeight: "bold" }}
                    />{" "}
                  </Col>
                )}

                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                  <label className="mb-1 fw-bold"> Financial Year </label>{" "}
                  <span style={{ color: "red" }}> *</span>
                  <Select
                    {...commonSelectProps({
                      name: "year",
                      options: yearList,
                      value: formik.values.year,
                      optionValueKey: "id",
                      optionLabelKey: "value",
                      formik,
                      isDisabled: false,
                      extraOnChange: (option) => {
                       formik.setFieldValue("month","");
                        setData([]);
                      },
                    })}
                  />
                </Col>

                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                  <label className="mb-1 fw-bold"> Month </label>{" "}
                  <span style={{ color: "red" }}> *</span>
                  <Select
                    {...commonSelectProps({
                      name: "month",
                      options: monthList,
                      value: formik.values.month,
                      optionValueKey: "month_order",
                      optionLabelKey: "month_name",
                      formik,
                      isDisabled: false,
                      extraOnChange: (option) => {
                        setMonthPeriod(option);
                        getData(formik.values.year, option?.month_order);
                        setData([]);
                      },
                    })}
                  />
                </Col>
              </Row>{" "}
            </div>
          </Form>{" "}
        </FormikProvider>

        {maintablenb && (
          <>
            <Row>
              <Col
                xs={12}
                sm={12}
                md={3}
                lg={3}
                xl={3}
                xxl={3}
                className=" mb-3"
              >
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    border: "1px solid #ddd",
                    borderRadius: "20px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s ease-in-out",
                    backgroundColor: "#fff",
                    padding: "5px 10px",
                    width: "150px",
                    minWidth: "150px",
                  }}
                  id="search-container"
                >
                  <AiOutlineSearch
                    className="me-2"
                    style={{
                      color: "#888",
                      fontSize: "1.2rem",
                      visibility: "visible",
                    }}
                  />
                  <input
                    type="text"
                    value={searchText}
                    placeholder="Search"
                    onFocus={(e) => {
                      const parent = e.currentTarget.parentElement;
                      parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)";
                      parent.style.border = "1px solid #353935";
                      parent.style.width = "100%";
                    }}
                    onChange={(e) => setSearch(e.target.value)}
                    onBlur={(e) => {
                      const parent = e.currentTarget.parentElement;
                      parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                      parent.style.border = "1px solid #ddd";
                      parent.style.width = "150px";
                    }}
                    style={{
                      flex: "1",
                      border: "none",
                      outline: "none",
                      fontSize: "1rem",
                      color: "#333",
                      backgroundColor: "transparent",
                      transition: "color 0.3s ease",
                      minWidth: "0",
                    }}
                  />
                </div>
              </Col>
              <Col className="mb-2">
                <button
                  size="sm"
                  className="btn mx-2 excel-btn"
                  onClick={() => exportToExcel("my-table", "KPIsvaluereport")}
                  style={{
                    float: "right",
                    color: "#ffffff",
                    marginLeft: "3px",
                  }}
                >
                  {" "}
                  Excel <AiFillFileExcel style={{ fontSize: "18px" }} />{" "}
                </button>
              </Col>
            </Row>
            <div
              style={{ textAlign: "center", backgroundColor: "#d4e3d8" }}
              className="rounded-1 border py-1"
            >
              <div className="style-1">
                {
                  distlist?.find((d) => d.id === formik.values.district_id)
                    ?.value
                }{" "}
                District - Key Performance Indicators with Values as on Current
                Month of{" "}
                {`20${yearList?.find((y) => y.id === formik.values.year)?.value?.split("-")[1]}`}
              </div>

              <div className="text-end style-1">
                Report On : {currentdate} {currenttime}
              </div>
            </div>
            <div id="table-scroll" className="table-scroll">
              <div className="table-wrap">
                <Table
                  bordered
                  id="my-table"
                  className="custom-table table-responsive table table-bordered sticky-table"
                >
             <thead>
  {/* TITLE */}
  <tr className="text-center only-export">
    <th colSpan={82} style={{ backgroundColor: "#d4e3d8" }}>
      <span className="style-1">
        {
          distlist?.find((d) => d.id === formik.values.district_id)?.value
        }{" "}
        District - Key Performance Indicators with Values as on Current Month of 2026
      </span>
    </th>
  </tr>

  {/* STATIC HEADERS */}
  <tr className="text-center">
    <th rowSpan={3} className="sticky-col sticky-sno">Sl.No.</th>
    <th rowSpan={3} className="sticky-col sticky-KPIHOD indicator-column">HOD Name</th>
    <th rowSpan={3} className="sticky-col sticky-KPIINDnew indicator-column">Indicator Name</th>
    <th rowSpan={3} className="sticky-col sticky-KPIvalueUNIT unit-column">Unit</th>
    <th rowSpan={3} className="sticky-col sticky-KPIvaluePERIODIC">Periodicity</th>
    <th rowSpan={3} className="sticky-col sticky-KPIvalueNaturenew">Positive / Negative</th>
    <th rowSpan={3} className="sticky-col sticky-KPIvalueEntrynew">Entry Level</th>

    <th rowSpan={3} className="sticky-col sticky-KPIvalueAchvmentnew">
      Achievements <br />
      {formik.values.year
        ? `${parseInt(formik.values.year.split("-")[0]) - 1}-${parseInt(formik.values.year.split("-")[1]) - 1}`
        : ""}
    </th>

    <th rowSpan={3} className="sticky-col sticky-KPIvalueTargetnew">
      Targets <br /> {formik.values.year}
    </th>

    {/* ✅ DYNAMIC HEADERS */}
    {(() => {
      const m = formik.values.month;

      const HEADER_MAP = {
        6: ["JUN", "Q1"],
        9: ["SEP", "Q2", "HY1"],
        12: ["DEC", "Q3"],
        3: ["MAR", "Q4", "HY2", "ANNUAL"]
      };

      if ([1,2,4,5,7,8,10,11].includes(m)) {
        return <th colSpan={3}>{monthPeriod.month_name}</th>;
      }

      return HEADER_MAP[m]?.map((h, i) => (
        <th key={i} colSpan={3}>{h}</th>
      ));
    })()}

    <th rowSpan={2}>Cumulative / Total</th>
    <th rowSpan={2}>% of Achievement</th>
  </tr>

  {/* SUB HEADERS */}
  <tr className="text-center">
    {(() => {
      const m = formik.values.month;

      const triple = () => (
        <>
          <th>Numerator</th>
          <th>Denominator</th>
          <th>Achieved</th>
        </>
      );

      const countMap = {
        6: 2,
        9: 3,
        12: 2,
        3: 4
      };

      if ([1,2,4,5,7,8,10,11].includes(m)) return triple();

      return Array.from({ length: countMap[m] || 0 }).map((_, i) => (
        <React.Fragment key={i}>{triple()}</React.Fragment>
      ));
    })()}
  </tr>
</thead>

       <tbody>
  {!filteredData || filteredData.length === 0 ? (
    <tr>
      <td colSpan={82} style={{ textAlign: "center", color: "red" }}>
        Details Not Found
      </td>
    </tr>
  ) : (
    (() => {
      let slno = 0;

      // ✅ GROUP BY DEPARTMENT
      const deptGroup = {};
      filteredData.forEach((item) => {
        if (!deptGroup[item.dept_id]) deptGroup[item.dept_id] = [];
        deptGroup[item.dept_id].push(item);
      });

      return Object.entries(deptGroup).flatMap(([deptId, deptRows]) => {
        const firstDeptRow = deptRows[0];

        // ✅ CHECK MANDAL ENTRY
        const hasMandalEntry = deptRows.some(
          (r) => r.enrty_type?.toLowerCase() === "mandal"
        );

        // ✅ GROUP BY INDICATOR
        const indicatorGroup = {};
        deptRows.forEach((item) => {
          if (!indicatorGroup[item.indicator_id])
            indicatorGroup[item.indicator_id] = [];
          indicatorGroup[item.indicator_id].push(item);
        });

        const indicators = Object.entries(indicatorGroup);
        const deptRowSpan = indicators.length;

        return indicators.map(([indicatorId, rows], idx) => {
          const first = rows[0];

          return (
            <tr key={indicatorId}>
              {/* SLNO */}
              <td
                className="sticky-col sticky-sno"
                style={{ textAlign: "center" }}
              >
                {++slno}
              </td>

              {/* HOD COLUMN */}
              {idx === 0 && (
                <td
                  rowSpan={deptRowSpan}
                  className="sticky-col sticky-KPIHOD indicator-column"
                  style={
                    hasMandalEntry
                      ? {
                          textAlign: "left",
                          verticalAlign: "top",
                          color: "blue",
                          cursor: "pointer",
                        }
                      : {
                          textAlign: "left",
                          verticalAlign: "top",
                        }
                  }
                  onClick={
                    hasMandalEntry
                      ? () => mandalWiseData(firstDeptRow.dept_id)
                      : undefined
                  }
                >
                  {firstDeptRow.hod_id}-{firstDeptRow.dept_name}
                </td>
              )}

              {/* STATIC COLUMNS */}
              <td className="sticky-col sticky-KPIINDnew indicator-column">
                {first.indicator_name}
              </td>
              <td className="sticky-col sticky-KPIvalueUNIT unit-column">
                {first.unit_name}
              </td>
              <td className="sticky-col sticky-KPIvaluePERIODIC">
                {first.periodic_name}
              </td>
              <td className="sticky-col sticky-KPIvalueNaturenew">
                {first.indicator_nature}
              </td>
              <td className="sticky-col sticky-KPIvalueEntrynew">
                {first.enrty_type}
              </td>
              <td
                className="sticky-col sticky-KPIvalueAchvmentnew"
                style={{ textAlign: "right" }}
              >
                {first.indicator_value_2024_25}
              </td>
              <td
                className="sticky-col sticky-KPIvalueTargetnew"
                style={{ textAlign: "right" }}
              >
                {first.targets_2025}
              </td>

              {/* ✅ DYNAMIC MONTH DATA (FIXED USING head_id) */}
              {(() => {
                const m = formik.values.month;

                // ✅ HEAD ID MAP
                const HEAD_MAP = {
                  6: [8, 15],
                  9: [11, 16, 1],
                  12: [14, 17],
                  3: [5, 18, 2, 0],
                };

                const getDataByHead = (headId) =>
                  rows.find(
                    (r) => parseInt(r.head_id) === headId
                  ) || {};

                const triple = (n, d, v) => (
                  <>
                    <td style={{ textAlign: "right" }}>
                      {n}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {d}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {v}
                    </td>
                  </>
                );

                // ✅ NORMAL MONTHS
                if ([1, 2, 4, 5, 7, 8, 10, 11].includes(m)) {
                  const data =
                    rows.find(
                      (r) => parseInt(r.month_order) === m
                    ) || {};

                  return triple(
                    data.numerator,
                    data.denominator,
                    data.head_indicator_value
                  );
                }

                // ✅ SPECIAL MONTHS
                const headIds = HEAD_MAP[m] || [];

                return headIds.map((id, i) => {
                  const d = getDataByHead(id);

                  return (
                    <React.Fragment key={i}>
                      {triple(
                        d.numerator,
                        d.denominator,
                        d.head_indicator_value
                      )}
                    </React.Fragment>
                  );
                });
              })()}

              {/* FINAL COLUMNS */}
              <td style={{ textAlign: "right" }}>
                {first.cumulative}
              </td>
              <td style={{ textAlign: "right" }}>
                {first.var_per}
              </td>
            </tr>
          );
        });
      });
    })()
  )}
</tbody>
                </Table>
              </div>
            </div>{" "}
          </>
        )}

        {SubTableEnb && (
          <>
            <Row>
              <Col
                xs={12}
                sm={12}
                md={3}
                lg={3}
                xl={3}
                xxl={3}
                className=" mb-3"
              >
                <div
                  style={{
                    display: "flex",
                    borderRadius: "20px",
                    alignItems: "center",
                    border: "1px solid #ddd",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s ease-in-out",
                    backgroundColor: "#fff",
                    padding: "5px 10px",
                    width: "150px",
                    minWidth: "150px",
                  }}
                  id="search-container"
                >
                  {" "}
                  <AiOutlineSearch
                    className="me-2"
                    style={{
                      fontSize: "1.2rem",
                      color: "#888",
                      visibility: "visible",
                    }}
                  />{" "}
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchSub}
                    onChange={(e) => setSearchsub(e.target.value)}
                    onFocus={(e) => {
                      const parent = e.currentTarget.parentElement;
                      parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)";
                      parent.style.border = "1px solid #353935";
                      parent.style.width = "100%";
                    }}
                    onBlur={(e) => {
                      const parent = e.currentTarget.parentElement;
                      parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                      parent.style.border = "1px solid #ddd";
                      parent.style.width = "150px";
                    }}
                    style={{
                      flex: "1",
                      border: "none",
                      outline: "none",
                      fontSize: "1rem",
                      color: "#333",
                      backgroundColor: "transparent",
                      transition: "color 0.3s ease",
                      minWidth: "0",
                    }}
                  />{" "}
                </div>{" "}
              </Col>
              <Col className="mb-2">
                <button
                  size="sm"
                  className="btn mx-2 excel-btn"
                  style={{
                    float: "right",
                    marginLeft: "3px",
                    color: "#ffffff",
                  }}
                  onClick={() => exportToExcel("my-table2", "KPIsvaluereport")}
                >
                  {" "}
                  Excel <AiFillFileExcel style={{ fontSize: "18px" }} />{" "}
                </button>
                <button
                  type="button"
                  size="sm"
                  className="btn btn-warning btn-sm mx-2 warn-btn"
                  style={{ float: "right", marginLeft: "3px" }}
                  onClick={() => {
                    setSubTableData([]);
                    setSubTableEnb(false);
                    setmaintablenb(true);
                    setSearch("");
                    setSearchsub("");
                  }}
                >
                  {" "}
                  <IoIosReturnLeft
                    style={{ fontSize: "18px", marginLeft: "5px" }}
                  />{" "}
                  Back{" "}
                </button>{" "}
              </Col>{" "}
            </Row>

            <div
              style={{ textAlign: "center", backgroundColor: "#d4e3d8" }}
              className="rounded-1 border py-1"
            >
              {" "}
              <div>
                <span className="style-1">
                  {
                    distlist?.find((d) => d.id === formik.values.district_id)
                      ?.value
                  }{" "}
                  District - Key Performance Indicators with Values as on
                  Current Month of{" "}
                  {`20${yearList?.find((y) => y.id === formik.values.year)?.value?.split("-")[1]}`}
                </span>
              </div>
              <div>
                <span className="style-1">Name Of The Department: </span>
                <span className="style-2">{subTableData[0]?.dept_name}</span>
              </div>
              <div className="text-end style-1">
                {" "}
                Report On : {currentdate} {currenttime}{" "}
              </div>{" "}
            </div>
            <div id="table-scroll" className="table-scroll">
              {" "}
              <div className="table-wrap">
                <Table
                  bordered
                  id="my-table2"
                  className="table table-bordered custom-table table-responsive sticky-table"
                >
                  <thead>
                    <tr className="text-center only-export">
                      <th
                        colSpan={3 + visibleIndicators.length * 6}
                        style={{
                          backgroundColor: "#d4e3d8",
                          textAlign: "center",
                        }}
                      >
                        {" "}
                        <span className="style-2">
                          {" "}
                          {
                            distlist?.find(
                              (d) => d.id === formik.values.district_id,
                            )?.value
                          }{" "}
                        </span>{" "}
                        <span className="style-1">
                          {" "}
                          District - Key Performance Indicators with Values as
                          on Current Month of{" "}
                          {` 20${yearList?.find((y) => y.id === formik.values.year)?.value?.split("-")[1]}`}{" "}
                        </span>{" "}
                        <br />{" "}
                        <span className="style-1">
                          Name Of The Department :{" "}
                        </span>{" "}
                        <span className="style-2">
                          {subTableData[0]?.dept_name}
                        </span>{" "}
                        <div className="text-end style-1">
                          {" "}
                          Report On : {currentdate} {currenttime}{" "}
                        </div>{" "}
                      </th>
                    </tr>

                    <tr className="text-center">
                      <th rowSpan={3} className="sticky-col sticky-sno">
                        Sl.No
                      </th>

                      <th
                        rowSpan={3}
                        className="sticky-col sticky-KPIHOD indicator-column"
                        style={{ minWidth: "200px" }}
                      >
                        Name of the <br /> Mandal / Municipality
                      </th>

                      <th rowSpan={3} className="sticky-col sticky-KPIPERIODIC">
                        Periodicity
                      </th>

                      {visibleIndicators.map((ind) => (
                        <th key={ind.indicator_id} colSpan={6}>
                         <div className="float-start">
Indicator Name:
<span className="style-2"> {ind.indicator_name}</span>
</div>

<div className="float-end">
Unit :
<span className="style-2"> {ind.unit_name}</span>
</div>
                        </th>
                      ))}
                    </tr>

                    <tr className="text-center">
                      {visibleIndicators.map((ind) => (
                        <React.Fragment key={ind.indicator_id}>
                          <th rowSpan={2}>
                            Achievements <br />
                            {`${parseInt(formik.values.year.split("-")[0]) - 1}-${String(parseInt(formik.values.year.split("-")[1]) - 1).padStart(2, "0")}`}
                          </th>

                          <th rowSpan={2}>
                            Targets <br />
                            {formik.values.year}
                          </th>

                          <th colSpan={4}>Achievements {formik.values.year}</th>
                        </React.Fragment>
                      ))}
                    </tr>

                    <tr className="text-center">
                      {visibleIndicators.map((ind) => (
                        <React.Fragment key={ind.indicator_id}>
                          <th>
                            Upto <br />
                            Previous
                            <br /> month
                          </th>
                          <th>
                            Current <br />
                            Month
                          </th>
                          <th>Cumulative</th>
                          <th>% Achievement</th>
                        </React.Fragment>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {mandalRowsFiltered.length === 0 ? (
                      <tr>
                        <td
                          colSpan={3 + visibleIndicators.length * 6}
                          className="text-center"
                        >
                          <b style={{ color: "red" }}>Details Not Found</b>
                        </td>
                      </tr>
                    ) : (
                      mandalRowsFiltered.map((mandalRows, index) => {
                        const mandalName = mandalRows[0]?.mandal_name;
                        const periodicity = mandalRows[0]?.periodic_name;

                        return (
                          <tr key={index}>
                            <td className="sticky-col sticky-sno text-center">
                              {index + 1}
                            </td>

                            <td className="sticky-col sticky-KPIHOD indicator-column">
                              {mandalName}
                            </td>

                            <td className="sticky-col sticky-KPIPERIODIC">
                              {periodicity}
                            </td>

                            {visibleIndicators.map((ind) => {
                              const data =
                                mandalRows.find(
                                  (r) => r.indicator_id === ind.indicator_id,
                                ) || {};

                              return (
                                <React.Fragment key={ind.indicator_id}>
                                  <td style={{ textAlign: "right" }}>
                                    {data?.indicator_value_2024_25 || 0}
                                  </td>

                                  <td style={{ textAlign: "right" }}>
                                    {data?.targets_2025 || 0}
                                  </td>

                                  <td style={{ textAlign: "right" }}>
                                    {data?.upto_previous_month_sum || 0}
                                  </td>

                                  <td style={{ textAlign: "right" }}>
                                    {data?.current_month_indicator_value || 0}
                                  </td>

                                  <td style={{ textAlign: "right" }}>
                                    {data?.cumulative || 0}
                                  </td>

                                  <td style={{ textAlign: "right" }}>
                                    {data?.var_per || 0}
                                  </td>
                                </React.Fragment>
                              );
                            })}
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        )}
      </Container>
      <AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
    </>
  );
}
